module.exports = __webpack_public_path__ + "static/media/Goto.300202dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Goto.svg
// module id = 1628
// module chunks = 0